import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/core/styles";
import { theme } from "../config/theme";
import realSign from "images/br.png";
import logo from "images/cap_logo.png";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import { numberAsCurrency } from './utils/index';
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import EditIcon from "@material-ui/icons/Edit";
import HomeIcon from "@material-ui/icons/Home";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import AwesomeIcon from "@material-ui/icons/FlashOn";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import SvgIcon from "@material-ui/core/SvgIcon";
import CampaignDetails from './pages/Campaign/CampaignDetails'
import { BrowserRouter as Router, Route, NavLink } from "react-router-dom";
import { useHistory, useLocation } from "react-router-dom";
import Home from "./pages/Home/Home.js";
import Termos from "./pages/Termos.js";
import Faq from "./pages/Faq.js";
import SmsConfirmation from "./pages/SmsConfirmation.js";
import WinnersIndex from "./pages/WinnersIndex.js";
import DocumentConfirmation from "./pages/DocumentConfirmation.js";
import EditProfile from "./pages/EditProfile.js";
import ChangeEmail from "./pages/ChangeEmail.js";
import ChangePhone from "./pages/ChangePhone.js";
import ChangeSocialName from "./pages/ChangeSocialName.js";
import Withdrawals from "./pages/Withdrawals.js";
import Withdrawal from "./pages/Withdrawal.js";
import ChangePassword from "./pages/ChangePassword.js";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import AccountRemove from "./pages/AccountRemove.js";
import axios from "axios";
import Container from "@material-ui/core/Container";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import "../public/styles/main.scss";
import SendConfirmationInstructions from "./components/SendConfirmationInstructions";
import MingCutePaperFillIcon from "./components/MingCutePaperFillIcon";
import SupportFab from "./components/SupportFab";
import Box from '@material-ui/core/Box';
import Footer from '../components/Footer.js'
import MyOrders from "./pages/MyOrders.js";
import CampaignsIndex from "./pages/CampaignsIndex.js";
import OrderPage from "./pages/Order/OrderPage.js";
import Cookie from "js-cookie";
import Politicas from './pages/Politicas.js';
import { flushPending, pushDataLayer, shouldReloadForLanding } from './utils';

export const UserContext = React.createContext(null);

function isCustomerHomePath(pathname, influencerUsername) {
  const basePath = `/${influencerUsername}`;
  const sitePath = `${basePath}/site`;
  const normalized = pathname.replace(/\/$/, "") || "/";
  const homePaths = [basePath, sitePath, "/site", "/"].map(
    (p) => p.replace(/\/$/, "") || "/"
  );
  return homePaths.includes(normalized);
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    marginTop: navigator.userAgent == "app-ios" ? "-50px" : ""
  },
  appBarShift: {
    width: "100%",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  drawerPaper: {
    backgroundColor: "#307432",
    width: "100vw",
    maxWidth: "420px",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: "20px 20px 12px",
    color: "#fff",
    minHeight: "96px",
    justifyContent: "space-between",
    [theme.breakpoints.down('xs')]: {
      minHeight: "90px",
    },
  },
  contentHeaderSpacer: {
    minHeight: "128px",
    [theme.breakpoints.down('sm')]: {
      minHeight: "64px",
    },
  },
  drawerLogo: {
    height: "58px",
    width: "auto",
    display: "block",
  },
  drawerCloseButton: {
    color: "#FFFFFF",
    padding: "8px",
    "& .MuiSvgIcon-root": {
      color: "#FFFFFF !important",
      fill: "#FFFFFF !important",
    },
  },
  drawerList: {
    paddingTop: 0,
  },
  drawerListItem: {
    minHeight: "66px",
    padding: "0 28px",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.06)",
    },
  },
  drawerDivider: {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  },
  drawerItemIcon: {
    color: "#89E683 !important",
    fill: "#89E683 !important",
    minWidth: "44px",
    "& .MuiSvgIcon-root": {
      fontSize: "1.7rem",
      color: "#89E683 !important",
      fill: "#89E683 !important",
    },
  },
  content: {
    flexGrow: 1,
    maxWidth: "-webkit-fill-available",
    textAlign: "-webkit-center",
    '@supports ( -moz-appearance:none )': {
      maxWidth: "-moz-available",
      textAlign: "-moz-center",
    },
    '@media(max-width: 1920px)': {
      minHeight: '600px',
    },
    '@media(max-width: 550px)': {
      minHeight: '825px',
    }
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  icons: {
    fill: "#FFFFFF",
  },
  menuIcons: {
    fill: "#fff !important",
  },
  signOut: {
    textDecoration: 'none',
    marginLeft: '10px',
    "@media(max-width: 375px)": {
      marginLeft: '2px',
    },
  },
  user: {
    backgroundColor: "transparent",
    width: "33px",
    minWidth: "33px",
    marginLeft: "10px",
    "&:hover": { backgroundColor: "rgba(255,255,255,0.15)" },
  },
  userBalance: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    position: "relative",
    zIndex: 2,
  },
  menuItemUser: {
    justifyContent: "space-around",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  profileMenuPaper: {
    backgroundColor: "#2D6E2F",
    color: "#FFFFFF",
    borderRadius: "14px",
    minWidth: "320px",
    maxWidth: "360px",
    boxShadow: "0 10px 26px rgba(0, 22, 72, 0.45)",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      minWidth: "300px",
      maxWidth: "calc(100vw - 24px)",
    },
  },
  profileMenuList: {
    padding: 0,
    backgroundColor: "#2D6E2F",
  },
  profileMenuDivider: {
    backgroundColor: "rgba(255, 255, 255, 0.28)",
  },
  profileMenuRow: {
    minHeight: "64px",
    padding: "0 16px",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start !important",
    gap: "12px",
    color: "#FFFFFF",
    backgroundColor: "#2D6E2F !important",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.07) !important",
    },
  },
  profileMenuIcon: {
    minWidth: "34px",
    color: "#89E683 !important",
    fill: "#89E683 !important",
    "& .MuiSvgIcon-root": {
      color: "#89E683 !important",
      fill: "#89E683 !important",
      fontSize: "1.75rem",
    },
  },
  profileMenuText: {
    color: "#FFFFFF",
    fontSize: "1.05rem",
    fontWeight: 500,
    lineHeight: 1.2,
    textAlign: "left",
    width: "100%",
  },
  profileBalanceArea: {
    padding: "14px 16px 16px",
    backgroundColor: "#2D6E2F",
  },
  profileBalanceHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "10px",
    color: "#FFFFFF",
    fontSize: "1.05rem",
    fontWeight: 500,
    lineHeight: 1.2,
    "& .MuiSvgIcon-root": {
      color: "#89E683 !important",
      fill: "#89E683 !important",
      fontSize: "1.75rem",
    },
  },
  profileBalanceCard: {
    backgroundColor: "#225424",
    borderRadius: "10px",
    padding: "10px 12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.28)",
  },
  profileBalanceValue: {
    color: "#FFFFFF",
    fontSize: "1.9rem",
    fontWeight: 700,
    lineHeight: 1.1,
    whiteSpace: "nowrap",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.45rem",
    },
  },
  profileWithdrawButton: {
    backgroundColor: "#89E683",
    color: "#225424",
    borderRadius: "8px",
    minWidth: "108px",
    height: "48px",
    fontSize: "0.82rem",
    fontWeight: 700,
    letterSpacing: "0.4px",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 12px",
    boxSizing: "border-box",
    "&:hover": {
      backgroundColor: "#7BDA75",
    },
    [theme.breakpoints.down("xs")]: {
      minWidth: "94px",
      height: "42px",
      fontSize: "0.78rem",
    },
  },
  menuWithdrawal: {
    backgroundColor: "#FFFFFF",
    background: "#FFFFFF",
    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
    width: "15%",
    textAlign: "center",
    justifyContent: "center",
    "@media(max-width: 1352px)": {
      minWidth: "20%",
      maxWidth: "25%",
    },
    "@media(max-width: 768px)": {
      minWidth: "35%",
      maxWidth: "50%",
    },
    "@media(max-width: 500px)": {
      minWidth: "65%",
      maxWidth: "80%",
    },
  },
  withdrawal: {
    backgroundColor: "#3B7E3D",
    borderRadius: "8px",
  },
  navLink: {
    textDecoration: "none",
  },
  navLinkSignOut: {
    display: "flex",
    textDecoration: "none",
  },
  marcaDiv: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    alignItems: 'center',
    zIndex: 1,
    [theme.breakpoints.up('md')]: {
      top: 30,
      transform: 'translateX(-50%)',
    },
  },
  toolbarRoot: {
    [theme.breakpoints.up('md')]: {
      minHeight: '96px',
    },
  },
  marcaA: {
    textDecoration: 'none',
    '@media(min-width: 1024px)': {
      // marginLeft: 150,
    }
  },
  marcaImg: {
    display: 'block',
    [theme.breakpoints.down('xs')]: {
      height: '38px',
    },
  },
  realSign: {
    verticalAlign: "text-top",
    margin: '5px 5px 0px 20px',
    '@media(max-width: 475px)': {
      margin: '6px 1px',
    }
  },
  menuBalance: {
    '@media(max-width: 475px)': {
      // display: 'none'
      fontSize: '0.8rem',
      paddingTop: '3px'
    }
  },
  userDollar: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '@media(max-width: 475px)': {
      '& > button': {
        marginLeft: '2px'
      }
    }
  },
  balanceChip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '2px',
    minHeight: '34px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('xs')]: {
      gap: '1px',
      minHeight: '30px',
    },
  },
  balanceChipIconWrap: {
    width: '28px',
    height: '28px',
    minWidth: '28px',
    borderRadius: '50%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#245826',
    border: '2px solid #93F27F',
    color: '#93F27F',
    boxSizing: 'border-box',
    [theme.breakpoints.down('xs')]: {
      width: '24px',
      height: '24px',
      minWidth: '24px',
    },
  },
  balanceChipIcon: {
    fontSize: '1rem',
    color: '#93F27F !important',
    fill: '#93F27F !important',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.85rem',
    },
  },
  balanceChipValue: {
    backgroundColor: '#245826',
    borderRadius: '999px',
    padding: '6px 12px 6px 0',
    color: '#FFFFFF',
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1,
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.8rem',
      padding: '5px 10px 5px 0',
    },
  },
  secondaryNav: {
    backgroundColor: '#2A5B2C',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0.5rem 2rem',
    width: '100%',
    boxSizing: 'border-box',
    [theme.breakpoints.up('md')]: {
      padding: '0.5rem 0',
    },
  },
  secondaryNavInner: {
    display: 'flex',
    alignItems: 'center',
    gap: '2.5rem',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      maxWidth: '768px',
    },
  },
  navBarInner: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    width: '100%',
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      maxWidth: '768px',
      margin: '0 auto',
    },
  },
  navItem: {
    color: '#FFFFFF',
    textDecoration: 'none',
    fontFamily: 'Inter, system-ui, sans-serif',
    fontWeight: 400,
    fontSize: '1rem',
    display: 'inline-block',
    background: 'transparent',
    padding: 0,
    borderRadius: 0,
    opacity: 0.9,
    '&:hover': {
      opacity: 1,
    },
  },
  navItemActive: {
    fontWeight: 700,
    opacity: 1,
    background: 'none',
  },
  navItemInactive: {
    fontWeight: 400,
    opacity: 0.9,
  },
  mobileBottomBar: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1300,
    backgroundColor: '#2A5B2C',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: '8px 6px calc(8px + env(safe-area-inset-bottom))',
    boxShadow: '0 -4px 14px rgba(0, 0, 0, 0.22)',
  },
  mobileNavItem: {
    flex: 1,
    minWidth: 0,
    textDecoration: 'none',
    color: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    fontWeight: 500,
    fontSize: '0.72rem',
    lineHeight: 1.15,
    opacity: 0.95,
    padding: '4px 2px',
    '&:hover': {
      opacity: 1,
    },
  },
  mobileNavItemActive: {
    color: '#86E873',
    fontWeight: 700,
  },
  mobileNavIcon: {
    fontSize: '1.7rem',
    color: 'currentColor',
    fill: 'currentColor',
  },
  mobileTicketIcon: {
    fontSize: '1.65rem',
    color: 'currentColor',
    fill: 'currentColor',
    '& path': {
      fill: 'currentColor',
    },
  },
  footer: {
    width: '100%',
    position: 'relative',
    bottom: 0,
    backgroundColor: '#2A5B2C',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 'calc(72px + env(safe-area-inset-bottom))',
    },
  },
  drawerText: {
    color: '#FFFFFF',
    "& .MuiTypography-root": {
      fontSize: "2rem",
      fontWeight: 500,
      letterSpacing: "0.2px",
    },
  },
  fab: {
    position: 'fixed',
    bottom: '24px',
    right: '24px',
    backgroundColor: '#3B7E3D',
    color: '#FFFFFF',
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 16px rgba(59, 126, 61, 0.4)',
    cursor: 'pointer',
    border: 'none',
    zIndex: 1200,
    '&:hover': {
      backgroundColor: '#316832',
    },
    [theme.breakpoints.down('sm')]: {
      bottom: '92px',
      right: '16px',
    },
  }
}));

export default function InnerApp({
  flash,
  global_schema,
  influencer,
  current_customer
}) {
  // , withdrawal_minimum_value
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(current_customer);
  const userReady = currentUser && currentUser.cpf == true;
  const history = useHistory();
  const location = useLocation();
  // Caminho da página de venda que responde pela home (vem do servidor): com
  // ela como interface principal, ou para quem ficou preso em /lp no teste.
  // A home do SPA leva de volta para lá.
  const lpPath = global_schema?.lp_path;
  const needsCpfValidation = currentUser && currentUser.cpf == false;
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // const [minimumValue, setMinimumValue] = useState(withdrawal_minimum_value);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [visitantAnchorEl, setVisitantAnchorEl] = React.useState(null);
  const query = new URLSearchParams(window.location.search);
  const influencerBasePath = `/${influencer?.username}`;
  const influencerSitePath = `${influencerBasePath}/site`;

  // const [drawerOpen, setDrawerOpen] = useState({ left: false });

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleVisitantClick = (event) => {
    setVisitantAnchorEl(event.currentTarget);
  };

  function handleLoginClick() {
    Cookie.set('redirect_to', window.location.href, { path: '/', expires: 1 });
    window.location.href = "/public/sign_in";
  }

  const handleClose = () => {
    setAnchorEl(null);
    setVisitantAnchorEl(null);
  };

  function handleDrawerOpen() {
    setOpen(true);
  }

  function handleDrawerClose() {
    setOpen(false);
  }

  function signOut(e) {
    e.preventDefault();
    setAnchorEl(null);
    setVisitantAnchorEl(null);
    setOpen(false);

    axios
      .delete("/customers/sign_out.json")
      .then(function (res) {
        setCurrentUser(null);
        history.push(`/${influencer?.username}/site`);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  // Precisa vir ANTES do effect abaixo: logado e com o cookie redirect_to, a
  // home é só a passagem de volta para a compra depois do login — o effect de
  // baixo consome o cookie e navega; sem essa ordem a trava ganharia a corrida.
  useEffect(() => {
    if (!lpPath || !isCustomerHomePath(location.pathname, influencer?.username)) return;
    if (currentUser && Cookie.get('redirect_to')) return;
    window.location.replace(lpPath);
  }, [location.pathname]);

  // Página de venda como interface principal: a página de uma campanha à venda
  // é do servidor, não do SPA. Chegando nela por navegação interna, recarrega.
  useEffect(() => {
    if (shouldReloadForLanding(location.pathname, global_schema?.lp_campaign_ids, window.sessionStorage)) {
      window.location.replace(window.location.href);
    }
  }, [location.pathname]);

  useEffect(() => {
    flushPending(pushDataLayer);

    if (userReady && Cookie.get('redirect_to')) {
      const redirect_to = Cookie.get('redirect_to');
      Cookie.remove('redirect_to');
      if (redirect_to) {
        const origin = window.location.origin;
        const redirectPath = redirect_to.startsWith(origin) ? redirect_to.replace(origin, '') : redirect_to;
        // A página de venda alternativa (/lp) não é rota do SPA: precisa de
        // navegação completa (chega aqui depois da confirmação de CPF).
        if (/^\/[^/]+\/lp\/\d+/.test(redirectPath)) {
          window.location.href = redirectPath;
        } else {
          history.push(redirectPath);
        }
      }
      return;
    }

    // Atualiza o titulo do documento usando a API do browser
    if (flash.notice) {
      toast.info(flash.notice);
    }
    if (flash.notice) {
      toast.warning(flash.alert);
    }
  }, [history, userReady]);

  const toggleDrawer = (open) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setOpen(open);
  };

  function handleOrdersClick(e) {
    e.preventDefault();
    if (userReady) {
      history.push(`/${influencer?.username}/site/compras`);
      setOpen(false);
    } else {
      Cookie.set('redirect_to', `/${influencer?.username}/site/compras`, { path: '/', expires: 1 });
      window.location.href = "/public/sign_in";
    }
  }

  const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);

  return (
    <div>
      <div className={classes.root}>
        <UserContext.Provider value={{ currentUser: currentUser, setCurrentUser: setCurrentUser }}>
          <CssBaseline />
          {navigator.userAgent != "app-ios" ? (
            <AppBar>
              <Toolbar className={classes.toolbarRoot} style={{ justifyContent: "center", color: "#fff", backgroundColor: "#2A5B2C" }}>
                <div className={classes.navBarInner}>
                <IconButton
                  color="inherit"
                  aria-label="open"
                  onClick={handleDrawerOpen}
                  edge="start"
                  className={clsx(classes.menuButton, open)}
                >
                  <MenuIcon className={classes.menuIcons} />
                </IconButton>
                <Typography
                  variant="h6"
                  component="div"
                  sx={{ flexGrow: 1 }}
                  className={classes.marcaDiv}
                >
                  <a href={`/${influencer?.username}`} className={classes.marcaA}>
                    <img
                      src={logo}
                      alt=""
                      title={"icone"}
                      height="50"
                      className={classes.marcaImg}
                    />
                  </a>
                </Typography>
                <div className={classes.userBalance}>
                  {userReady ? (
                    <>
                      <div className={classes.userBalance}>
                        <div
                          className={classes.userDollar}
                          aria-controls="user-menu"
                          aria-haspopup="true"
                          onClick={handleClick}
                        >
                          <div className={classes.balanceChip}>
                            <span className={classes.balanceChipIconWrap}>
                              <PersonOutlineIcon className={classes.balanceChipIcon} />
                            </span>
                            <Typography className={classes.balanceChipValue}>
                              {numberAsCurrency(currentUser.balance || 0)}
                            </Typography>
                          </div>
                        </div>
                      </div>
                    </>
                  ) :
                    (
                      needsCpfValidation ?
                        (
                          <div>
                            <NavLink className={classes.navLinkSignOut} to="#" onClick={signOut}>
                              <ExitToAppIcon className={classes.menuIcons} />
                              <Typography className={classes.signOut} style={{ color: '#FFFFFF' }}>Sair</Typography>
                            </NavLink>
                          </div>
                        ) :
                        <>
                          <div className={classes.userBalance}>
                            <div
                              className={classes.userDollar}
                              aria-controls="visitant-menu"
                              aria-haspopup="true"
                              onClick={handleVisitantClick}
                            >
                              <Button className={classes.user} color="inherit">
                                <PersonOutlineIcon className={classes.icons} />
                              </Button>
                            </div>
                          </div>
                        </>
                    )}
                  <Menu
                    id="user-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    classes={{
                      paper: classes.profileMenuPaper,
                      list: classes.profileMenuList,
                    }}
                  >
                    <NavLink
                      className={classes.navLink}
                      to="/site/change_profile"
                      onClick={() => setOpen(false)}
                    >
                      <MenuItem
                        className={classes.profileMenuRow}
                        onClick={handleClose}
                      >
                        <ListItemIcon className={classes.profileMenuIcon}>
                          <PersonOutlineIcon />
                        </ListItemIcon>
                        <Typography className={classes.profileMenuText}>
                          {currentUser?.best_name}
                        </Typography>
                      </MenuItem>
                    </NavLink>
                    {
                      currentUser && currentUser.balance && currentUser.balance > 0 &&
                      <>
                        <Divider className={classes.profileMenuDivider} />
                        <div className={classes.profileBalanceArea}>
                          <div className={classes.profileBalanceHeader}>
                            <LocalAtmIcon />
                            <span>Saldo Disponível</span>
                          </div>
                          <div className={classes.profileBalanceCard}>
                            <Typography className={classes.profileBalanceValue}>
                              {numberAsCurrency(currentUser.balance) || "R$ 0,00"}
                            </Typography>
                            <NavLink
                              to="/site/withdrawal"
                              className={classes.profileWithdrawButton}
                              onClick={handleClose}
                            >
                              SACAR
                            </NavLink>
                          </div>
                        </div>
                      </>
                    }
                    <Divider className={classes.profileMenuDivider} />
                    <NavLink
                      className={classes.navLink}
                      to="#"
                      onClick={signOut}
                    >
                      <MenuItem
                        className={classes.profileMenuRow}
                        onClick={handleClose}
                      >
                        <ListItemIcon className={classes.profileMenuIcon}>
                          <ExitToAppIcon />
                        </ListItemIcon>
                        <Typography className={classes.profileMenuText}>
                          Sair
                        </Typography>
                      </MenuItem>
                    </NavLink>
                  </Menu>
                  <Menu
                    id="visitant-menu"
                    anchorEl={visitantAnchorEl}
                    open={Boolean(visitantAnchorEl)}
                    onClose={handleClose}
                    classes={{
                      paper: classes.menuWithdrawal,
                    }}
                  >
                    <NavLink
                      className={classes.navLink}
                      to="#"
                      onClick={handleLoginClick}
                    >
                      <MenuItem
                        className={classes.menuItemUser}
                        onClick={handleClose}
                      >
                        <PersonOutlineIcon className={classes.icons} />
                        <Typography
                          style={{ width: "100%", textAlign: "center", color: '#1A1A1A' }}
                        >
                          Entrar
                        </Typography>
                      </MenuItem>
                    </NavLink>
                  </Menu>
                </div>
                </div>
              </Toolbar>
              {!isMobile && (
                <div className={classes.secondaryNav}>
                  <div className={classes.secondaryNavInner}>
                    <NavLink
                      className={classes.navItem}
                      activeClassName={classes.navItemActive}
                      to={`/${influencer?.username}/site/campanhas`}
                      onClick={() => setOpen(false)}
                    >
                      Campanhas
                    </NavLink>
                    <NavLink
                      className={classes.navItem}
                      activeClassName={classes.navItemActive}
                      to={`/${influencer?.username}/site/ganhadores`}
                      onClick={() => setOpen(false)}
                    >
                      Ganhadores
                    </NavLink>
                    <NavLink
                      className={classes.navItem}
                      activeClassName={classes.navItemActive}
                      to={`/${influencer?.username}/site/compras`}
                      onClick={handleOrdersClick}
                    >
                      Meus Títulos
                    </NavLink>
                  </div>
                </div>
              )}
            </AppBar>)
            : ("")}
          {!currentUser || userReady ? (
            <SwipeableDrawer
              anchor="left"
              open={open}
              onClose={toggleDrawer(false)}
              onOpen={toggleDrawer(true)}
              disableBackdropTransition={!iOS}
              disableDiscovery={iOS}
              classes={{
                paper: classes.drawerPaper,
              }}
            >
              <div className={classes.drawerHeader}>
                <img
                  src={logo}
                  alt="Cap logo"
                  className={classes.drawerLogo}
                />
                <IconButton className={classes.drawerCloseButton} onClick={handleDrawerClose}>
                  <CloseIcon />
                </IconButton>
              </div>
              <Divider className={classes.drawerDivider} />
              <List className={classes.drawerList}>
                {currentUser && currentUser.email.length > 1 && !currentUser.confirmed_at && <SendConfirmationInstructions />}
                <Divider className={classes.drawerDivider} />
                <NavLink
                  className={classes.navLink}
                  to={`/${influencer?.username}/site`}
                  onClick={() => setOpen(false)}
                >
                  <ListItem button key="home" className={classes.drawerListItem}>
                    <ListItemIcon className={classes.drawerItemIcon}>
                      <HomeIcon className={classes.menuIcons} />
                    </ListItemIcon>
                    <ListItemText classes={{ primary: classes.drawerText }} primary="Início" />
                  </ListItem>
                </NavLink>
                <Divider className={classes.drawerDivider} />
                <NavLink
                  className={classes.navLink}
                  to={`/${influencer?.username}/site/campanhas`}
                  onClick={() => setOpen(false)}
                >
                  <ListItem button key="campanhas" className={classes.drawerListItem}>
                    <ListItemIcon className={classes.drawerItemIcon}>
                      <AwesomeIcon className={classes.menuIcons} />
                    </ListItemIcon>
                    <ListItemText classes={{ primary: classes.drawerText }} primary="Campanhas" />
                  </ListItem>
                </NavLink>
                <Divider className={classes.drawerDivider} />
                <NavLink
                  className={classes.navLink}
                  to={`/${influencer?.username}/site/ganhadores`}
                  onClick={() => setOpen(false)}
                >
                  <ListItem button key="ganhadores" className={classes.drawerListItem}>
                    <ListItemIcon className={classes.drawerItemIcon}>
                      <EmojiEventsIcon className={classes.menuIcons} />
                    </ListItemIcon>
                    <ListItemText classes={{ primary: classes.drawerText }} primary="Ganhadores" />
                  </ListItem>
                </NavLink>
                <Divider className={classes.drawerDivider} />
                <NavLink
                  className={classes.navLink}
                  to="#"
                  onClick={handleOrdersClick}
                >
                  <ListItem button key="compras" className={classes.drawerListItem}>
                    <ListItemIcon className={classes.drawerItemIcon}>
                      <SvgIcon className={classes.menuIcons} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                        <path d="M22 10V6c0-1.11-.9-2-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-9 7.5h-2v-2h2v2zm0-4.5h-2v-2h2v2zm0-4.5h-2v-2h2v2z"></path>
                      </SvgIcon>
                    </ListItemIcon>
                    <ListItemText classes={{ primary: classes.drawerText }} primary="Meus títulos" />
                  </ListItem>
                </NavLink>
                <Divider className={classes.drawerDivider} />
                {
                  userReady && (
                    <NavLink
                      className={classes.navLink}
                      to="/site/withdrawals"
                      onClick={() => setOpen(false)}
                    >
                      <ListItem button key="withdrawals" className={classes.drawerListItem}>
                        <ListItemIcon className={classes.drawerItemIcon}>
                          <MonetizationOnIcon className={classes.menuIcons} />
                        </ListItemIcon>
                        <ListItemText classes={{ primary: classes.drawerText }} primary="Meus Saques" />
                      </ListItem>
                    </NavLink>
                  )
                }
                <Divider className={classes.drawerDivider} />
                <NavLink
                  className={classes.navLink}
                  to="/site/politicas"
                  onClick={() => setOpen(false)}
                >
                  <ListItem button key="politicas" className={classes.drawerListItem}>
                    <ListItemIcon className={classes.drawerItemIcon}>
                      <MingCutePaperFillIcon className={classes.menuIcons} />
                    </ListItemIcon>
                    <ListItemText classes={{ primary: classes.drawerText }} primary="Políticas" />
                  </ListItem>
                </NavLink>
                <Divider className={classes.drawerDivider} />
                <NavLink
                  className={classes.navLink}
                  to="/site/termos"
                  onClick={() => setOpen(false)}
                >
                  <ListItem button key="termos" className={classes.drawerListItem}>
                    <ListItemIcon className={classes.drawerItemIcon}>
                      <LibraryBooksIcon className={classes.menuIcons} />
                    </ListItemIcon>
                    <ListItemText classes={{ primary: classes.drawerText }} primary="Termos de Uso" />
                  </ListItem>
                </NavLink>
                <Divider className={classes.drawerDivider} />
                <NavLink
                  className={classes.navLink}
                  to="/site/faq"
                  onClick={() => setOpen(false)}
                >
                  <ListItem button key="faq" className={classes.drawerListItem}>
                    <ListItemIcon className={classes.drawerItemIcon}>
                      <HelpOutlineIcon className={classes.menuIcons} />
                    </ListItemIcon>
                    <ListItemText classes={{ primary: classes.drawerText }} primary="Dúvidas Frequentes" />
                  </ListItem>
                </NavLink>
                <Divider className={classes.drawerDivider} />
                {
                  userReady && (
                    <NavLink
                      className={classes.navLink}
                      to="/site/change_profile"
                      onClick={() => setOpen(false)}
                    >
                      <ListItem button key="change_profile" className={classes.drawerListItem}>
                        <ListItemIcon className={classes.drawerItemIcon}>
                          <EditIcon className={classes.menuIcons} />
                        </ListItemIcon>
                        <ListItemText classes={{ primary: classes.drawerText }} primary="Editar Perfil" />
                      </ListItem>
                    </NavLink>
                  )
                }
                <Divider className={classes.drawerDivider} />
                {
                  userReady && (
                    <NavLink className={classes.navLink} to="#" onClick={signOut}>
                      <ListItem button key="counter" className={classes.drawerListItem}>
                        <ListItemIcon className={classes.drawerItemIcon}>
                          <ExitToAppIcon className={classes.menuIcons} />
                        </ListItemIcon>
                        <ListItemText classes={{ primary: classes.drawerText }} primary="Sair" />
                      </ListItem>
                    </NavLink>
                  )
                }
                <Divider className={classes.drawerDivider} />
              </List>
            </SwipeableDrawer>
          ) : (
            ""
          )}
          <main
            className={clsx(classes.content, {
              [classes.contentShift]: open,
            })}
          >
            <div className={classes.contentHeaderSpacer} />
            <ToastContainer autoClose={8000} />
            <div>
              {
                needsCpfValidation ?
                  <Container className={classes.paper} maxWidth="xs">
                    <Route exact path={["/:influencer_username", "/:influencer_username/site", "/site", "*"]}>
                      <DocumentConfirmation />
                    </Route>
                  </Container>
                  :
                  <Route exact path={["/:influencer_username", "/:influencer_username/site", "/site", "/"]}>
                    <Home currentUser={currentUser} influencer={influencer} isMobile={isMobile} />
                  </Route>
              }
              {
                userReady &&
                <Route exact path={["/:influencer_username/site/change_profile", "/site/change_profile"]}>
                  <EditProfile user={currentUser} />
                </Route>
              }
              {
                userReady &&
                <>
                  <Container maxWidth="xs">
                    <Route exact path={["/:influencer_username/site/change_email", "/site/change_email"]}>
                      <ChangeEmail user={currentUser} />
                    </Route>
                    <Route exact path={["/:influencer_username/site/change_phone", "/site/change_phone"]}>
                      <ChangePhone />
                    </Route>
                    <Route exact path={["/:influencer_username/site/change_password", "/site/change_password"]}>
                      <ChangePassword user={currentUser} />
                    </Route>
                    <Route exact path={["/:influencer_username/site/change_social_name", "/site/change_social_name"]}>
                      <ChangeSocialName user={currentUser} />
                    </Route>
                    <Route exact path={["/:influencer_username/site/withdrawal", "/site/withdrawal"]}>
                      <Withdrawal currentUser={currentUser} />
                    </Route>
                    <Route exact path={["/:influencer_username/site/account_remove", "/site/account_remove"]}>
                      <AccountRemove user={currentUser} />
                    </Route>
                  </Container>
                  <Route exact path={["/:influencer_username/site/withdrawals", "/site/withdrawals"]}>
                    <Withdrawals currentUser={currentUser} incluencer={influencer} />
                  </Route>
                </>
              }
              {
                !needsCpfValidation &&
                <>
                  <Route exact path={["/:influencer_username/site/campanhas/:campaignId", "/site/campanhas/:campaignId"]}>
                    <CampaignDetails currentUser={currentUser} influencer={influencer} />
                  </Route>
                  <Route exact path={["/:influencer_username/site/ganhadores", "/site/ganhadores"]}>
                    <WinnersIndex currentUser={currentUser} influencer={influencer} />
                  </Route>
                  <Route exact path={["/:influencer_username/site/compras", "/site/compras"]}>
                    <MyOrders currentUser={currentUser} influencer={influencer} />
                  </Route>
                  <Route exact path={["/:influencer_username/site/compras/:orderId", "/site/compras/:orderId"]}>
                    <OrderPage currentUser={currentUser} influencer={influencer} />
                  </Route>
                  <Route exact path={["/:influencer_username/site/campanhas", "/site/campanhas"]}>
                    <CampaignsIndex currentUser={currentUser} influencer={influencer} />
                  </Route>
                  <Route exact path={["/:influencer_username/site/termos", "/site/termos"]}>
                    <Termos content={global_schema.terms} />
                  </Route>
                  <Route exact path={["/:influencer_username/site/politicas", "/site/politicas"]}>
                    <Politicas content={global_schema.politicas} />
                  </Route>
                  <Route exact path={["/:influencer_username/site/faq", "/site/faq"]}>
                    <Faq content={global_schema.faq} />
                  </Route>
                </>
              }
            </div>
          </main>
        </UserContext.Provider>
      </div>
      {navigator.userAgent != "app-ios" ? (
        <Box className={classes.footer}>
          <Footer />
        </Box>) : ("")
      }
      {isMobile && (
        <div className={classes.mobileBottomBar}>
          <NavLink
            to={influencerSitePath}
            className={classes.mobileNavItem}
            activeClassName={classes.mobileNavItemActive}
            isActive={(_match, loc) =>
              isCustomerHomePath(loc.pathname, influencer?.username)
            }
          >
            <HomeIcon className={classes.mobileNavIcon} />
            <span>Início</span>
          </NavLink>
          <NavLink
            to={`/${influencer?.username}/site/campanhas`}
            className={classes.mobileNavItem}
            activeClassName={classes.mobileNavItemActive}
          >
            <AwesomeIcon className={classes.mobileNavIcon} />
            <span>Campanhas</span>
          </NavLink>
          <NavLink
            to={`/${influencer?.username}/site/ganhadores`}
            className={classes.mobileNavItem}
            activeClassName={classes.mobileNavItemActive}
          >
            <EmojiEventsIcon className={classes.mobileNavIcon} />
            <span>Ganhadores</span>
          </NavLink>
          <NavLink
            to={`/${influencer?.username}/site/compras`}
            className={classes.mobileNavItem}
            activeClassName={classes.mobileNavItemActive}
            onClick={handleOrdersClick}
          >
            <SvgIcon className={classes.mobileTicketIcon} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M22 10V6c0-1.11-.9-2-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-9 7.5h-2v-2h2v2zm0-4.5h-2v-2h2v2zm0-4.5h-2v-2h2v2z"></path>
            </SvgIcon>
            <span>Meus Títulos</span>
          </NavLink>
        </div>
      )}
      <SupportFab url={global_schema?.support_url} className={classes.fab} />
    </div>
  );
}
